import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import ServiceCard from "./ServiceCard";
import PageSeo from "../SEO/PageSeo";
import { FaRobot, FaCogs, FaGlobe, FaPenFancy } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";

function Services() {
  const { t } = useLanguage();
  return (
    <Container fluid className="project-section">
      <PageSeo
        title={t("seo.services.title")}
        description={t("seo.services.description")}
        breadcrumbItems={[
          { name: t("nav.home"), path: "/" },
          { name: t("nav.services"), path: "/services" },
        ]}
      />
      <Particle />
      <Container>
        <h1 className="project-heading text-center">
          {t("servicesPage.h1a")}
          <strong className="purple">{t("servicesPage.h1b")}</strong>
        </h1>
        <p className="text-center text-white-50 mb-2">{t("servicesPage.p1")}</p>
        <p className="text-center text-white-50 mb-5">{t("servicesPage.p2")}</p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={6} lg={5} className="project-card">
            <ServiceCard
              icon={FaRobot}
              title={t("servicesDetail.chatbot.title")}
              bullets={t("servicesDetail.chatbot.bullets")}
            />
          </Col>
          <Col md={6} lg={5} className="project-card">
            <ServiceCard
              icon={FaCogs}
              title={t("servicesDetail.automation.title")}
              bullets={t("servicesDetail.automation.bullets")}
            />
          </Col>
          <Col md={6} lg={5} className="project-card">
            <ServiceCard
              icon={FaGlobe}
              title={t("servicesDetail.sites.title")}
              bullets={t("servicesDetail.sites.bullets")}
            />
          </Col>
          <Col md={6} lg={5} className="project-card">
            <ServiceCard
              icon={FaPenFancy}
              title={t("servicesDetail.content.title")}
              bullets={t("servicesDetail.content.bullets")}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Services;
